export const getDayMonthYear = (date: string) => {
    if (date) {
        const formattedDate = new Date(date);
        const d = formattedDate.getDate();
        const m = formattedDate.getMonth() + 1;
        const y = formattedDate.getFullYear();
        const day = d > 9 ? d : `0${d}`;
        const month = m > 9 ? m : `0${m}`;
        return `${day}/${month}/${y}`;
    }
    return '';
};

export const getFieldActionName = (fieldName: string) => {
    switch (fieldName) {
        case 'invoice_date':
            return 'enter_invoice_date';
        case 'bin2':
            return 'enter_bin2';
        case 'registration_number':
            return 'enter_registration_number';
        case 'motor_number':
            return 'enter_motor_number';
        case 'charger_number':
            return 'enter_charger_number';
        case 'rto':
            return 'enter_rto';
        default:
            return '';
    }
};
